export const ROLES = {
  SUPERVISOR: 'SUPERVISOR',
  TALENT: 'TALENT',
};
export const USER_HISTORY_LIMIT = 10;
export const CALL_STATUSES = {
  CREATED: 'created',
  COMPLETED: 'completed',
  DIALING: 'dialing',
};
export const ERROR_CODES = {
  // Category: USER_ERROR
  PHONE_UNAUTHORIZED: 'PHONE_UNAUTHORIZED',
  PHONE_NOT_ALLOWED: 'PHONE_NOT_ALLOWED',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
  VERIFICATION_EXPIRED: 'VERIFICATION_EXPIRED',
  INVALID_VERIFICATION_CODE: 'INVALID_VERIFICATION_CODE',
  UNSUPPORTED_NEXMO_NETWORK: 'UNSUPPORTED_NEXMO_NETWORK',
  NEXMO_VERIFICATION_IN_PROGRESS: 'NEXMO_VERIFICATION_IN_PROGRESS',
  INCORRECT_FORMAT: 'INCORRECT_FORMAT',
  // Category: CLIENT_ERROR
  JWT_NOT_VERIFIED: 'JWT_NOT_VERIFIED',
  UNKNOWN_TOKEN_PAIR: 'UNKNOWN_TOKEN_PAIR',
  EXPIRED_REFRESH_TOKEN : 'EXPIRED_REFRESH_TOKEN',
  REQUEST_ERROR: 'REQUEST_ERROR',
  EXPIRED_JWT: 'EXPIRED_JWT',
  // Category: OTHER
  OTHER: 'OTHER',
};
export const ERROR_CATEGORIES = {
  CLIENT_ERROR: 'CLIENT_ERROR',
  USER_ERROR: 'USER_ERROR',
  OTHER: 'OTHER',
};
export const ERROR_DESCRIPTION = {
  // Category: USER_ERROR
  PHONE_UNAUTHORIZED: 'Phone is not recognized',
  PHONE_NOT_ALLOWED: 'Common Nexmo API returned error',
  VERIFICATION_FAILED: 'The supplied verification id could not be found in DynamoDB',
  VERIFICATION_EXPIRED: 'The supplied verification id could not be found in DynamoDB',
  UNSUPPORTED_NEXMO_NETWORK: 'Nexmo API specific error',
  NEXMO_VERIFICATION_IN_PROGRESS: 'Nexmo API specific error',
  INCORRECT_FORMAT: 'Provided phone number could not be normalized to E164',
  // Category: CLIENT_ERROR
  JWT_NOT_VERIFIED: 'Could not verify the supplied JWT',
  UNKNOWN_TOKEN_PAIR: 'No such token key-pair found in DynamoDB',
  EXPIRED_REFRESH_TOKEN : 'The supplied refresh token is no longer valid',
  REQUEST_ERROR: 'Missing required query parameter or unsupported http method',
  EXPIRED_JWT: 'Access token has expired',
  // Category: OTHER
  OTHER: 'Undefined error[OTHER]',
};

export const ERROR_MESSAGES = {
  // Category: USER_ERROR
  PHONE_UNAUTHORIZED: {
    title: 'Number Not Authorized',
    text: 'Contact your IT department to use this number with NCI Connect.',
  },
  PHONE_NOT_ALLOWED: 'Common Nexmo API returned error',
  VERIFICATION_FAILED: 'The supplied verification id could not be found in DynamoDB',
  VERIFICATION_EXPIRED: 'The supplied verification id could not be found in DynamoDB',
  UNSUPPORTED_NEXMO_NETWORK: 'Nexmo API specific error',
  NEXMO_VERIFICATION_IN_PROGRESS: 'Nexmo API specific error',
  INCORRECT_FORMAT: 'Provided phone number could not be normalized to E164',
  // Category: CLIENT_ERROR
  JWT_NOT_VERIFIED: 'Could not verify the supplied JWT',
  UNKNOWN_TOKEN_PAIR: 'No such token key-pair found in DynamoDB',
  EXPIRED_REFRESH_TOKEN : 'The supplied refresh token is no longer valid',
  REQUEST_ERROR: 'Missing required query parameter or unsupported http method',
  EXPIRED_JWT: 'Access token has expired',
  // Category: OTHER
  OTHER: 'Undefined error[OTHER]',
};
